var map = {
	"./Document_classification.png": 1248,
	"./Document_classification_white.png": 3582,
	"./Gradio_Application.png": 811,
	"./Gradio_Application_white.png": 433,
	"./IJS logo-01.png": 3245,
	"./IJS logo-02.png": 8358,
	"./IJS_JSI_logo-01.png": 1727,
	"./IJS_JSI_logo-02.png": 7236,
	"./LLM.png": 9831,
	"./LLM_white.png": 6541,
	"./NLP E8 Logo.png": 4404,
	"./NLP_E8_Logo_bel.png": 5406,
	"./Other.png": 2096,
	"./Other_white.png": 8766,
	"./Sequence_labelling.png": 6944,
	"./Sequence_labelling_white.png": 5358,
	"./background.png": 9528,
	"./gender_classification.png": 6564,
	"./keyword_extraction.png": 6035,
	"./rsdo_footer.png": 5246,
	"./rsdo_logo.png": 7250,
	"./semantic_shift.png": 1705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;